import { render, staticRenderFns } from "./TransferPaymentDetails.vue?vue&type=template&id=bc4229cc&"
import script from "./TransferPaymentDetails.vue?vue&type=script&lang=js&"
export * from "./TransferPaymentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports